import { useMemo, useState } from 'react'
import * as React from 'react'
import { SubmitButton } from '../components/SubmitButton'

type Props = {
  onSubmit: (name: string) => void
}

const WebsiteNameForm: React.FC<Props> = ({ onSubmit }) => {
  const [websiteName, setWebsiteName] = useState<string>('')

  const handleOnSubmit = () => {
    onSubmit(websiteName)
  }

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setWebsiteName(e.target.value)
  }

  const canSubmit = useMemo(() => {
    return websiteName !== ''
  }, [websiteName])

  return (
    <div className="website-claim-address-form-container">
      <form onSubmit={handleOnSubmit}>
        <h2 className="website-claim-address-form-title">Welcome to POAP websites</h2>
        <p className="website-claim-address-form-message">Please enter a website name to claim your POAP</p>
        <input
          type="text"
          placeholder="Input a website name"
          value={websiteName}
          onChange={handleOnChange}
          className="address-input"
        />
        <SubmitButton text="Submit" isSubmitting={false} canSubmit={canSubmit} className="btn" />
      </form>
    </div>
  )
}

export default WebsiteNameForm
